import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, DialogProps, Typography } from '@mui/material';
import React, { memo, useCallback } from 'react';

import { useAppDispatch } from '~/store/hooks';
import { logout } from '~/store/slices/user';

import styles from './styles.module.scss';

interface Props extends Omit<DialogProps, 'onClose'> {
  onClose: () => void;
}

const Component: React.FC<Props> = ({ open, onClose, ...props }) => {
  const dispatch = useAppDispatch();

  const handleLogout = useCallback(() => {
    onClose();

    dispatch(logout());
  }, [dispatch, onClose]);

  return (
    <Dialog open={open} onClose={onClose} {...props}>
      <div className={styles['logout-modal']}>
        <button
          aria-label="close"
          className={styles['logout-modal__close']}
          type="button"
          onClick={onClose}
        >
          <CloseIcon sx={{ width: '18px', height: '18px', color: 'var(--gray-2-color)' }} />
        </button>
        <Typography color="text.primary" mb={35} variant="h5">
          Logout
        </Typography>
        <Typography color="var(--text-3-color)" mb={36} variant="subtitle1">
          Are you sure you want to logout?
        </Typography>
        <div className={styles['logout-modal__buttons']}>
          <Button
            color="secondary"
            sx={{ width: '160px', color: 'var(--text-3-color)' }}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button sx={{ width: '160px' }} onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export const LogoutModal = memo(Component);
